import { api } from './api';

// ==================== DTOs ====================

export interface UserAnalyticsSummaryDto {
  userId: string;
  lastCalculatedAt: string;
  totalProjects: number;
  completedProjects: number;
  archivedProjects: number;
  totalSessions: number;
  totalSessionMinutes: number;
  averageSessionMinutes: number;
  completionRate: number;
  currentStreak: number;
  longestStreak: number;
  bestWorkHour: number;
  bestWorkDay: number;
  stageStuckMost?: string;
  averageCompletionDays: number;
}

export interface SessionHeatmapSlotDto {
  dayOfWeek: number;
  hourOfDay: number;
  sessionCount: number;
  totalMinutes: number;
  averageMood?: number;
}

export interface PredictiveInsightDto {
  title: string;
  description: string;
  confidence: number;
  category: string;
}

// ==================== Service ====================

export const analyticsService = {
  /**
   * Get the analytics summary for the current user.
   */
  async getSummary(): Promise<UserAnalyticsSummaryDto | null> {
    try {
      return await api.get<UserAnalyticsSummaryDto>('/analytics/summary');
    } catch {
      return null;
    }
  },

  /**
   * Get the session heatmap data (7 days x 24 hours).
   */
  async getHeatmap(): Promise<SessionHeatmapSlotDto[]> {
    return api.get<SessionHeatmapSlotDto[]>('/analytics/heatmap');
  },

  /**
   * Get AI-generated predictive insights.
   */
  async getPredictions(): Promise<PredictiveInsightDto[]> {
    return api.get<PredictiveInsightDto[]>('/analytics/predictions');
  },

  /**
   * Trigger a recalculation of analytics.
   */
  async recalculate(): Promise<void> {
    await api.post('/analytics/recalculate', {});
  },
};
